import type { ResourceConfig } from '../../interfaces/ResourceConfig';

/**
 * @internal
 * Client-side config storage - use a stack to handle mount/unmount properly
 */
export const configStack: ResourceConfig[] = [];
